import {
  GetIndustriesResponse,
  GetIndustryResponse,
  IndustryFormType,
  IndustryType,
} from '@consolidocs-ui/types';
import { enhanceEndpoints } from '../core';

const IndustryApiWithTag = enhanceEndpoints({
  addTagTypes: ['industries'],
});

// Industry API Services
export const IndustryApi = IndustryApiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    getIndustries: builder.query<GetIndustriesResponse, void>({
      query: () => ({
        url: 'industry-types',
      }),
      providesTags: ['industries'],
    }),
    getIndustry: builder.query<GetIndustryResponse, string>({
      query: (id) => ({
        url: `industry-types/${id}`,
      }),
    }),
    // Write payloads use the form shape: contract_types as id strings.
    createIndustry: builder.mutation<IndustryType, IndustryFormType>({
      query: (industry) => {
        return {
          url: `industry-types`,
          method: 'POST',
          data: industry,
        };
      },
      invalidatesTags: ['industries'],
    }),

    updateIndustries: builder.mutation<
      IndustryType,
      IndustryFormType & { id?: string }
    >({
      query: (industry) => {
        return {
          url: `industry-types/${industry.id}`,
          method: 'PUT',
          data: industry,
        };
      },
      invalidatesTags: ['industries'],
    }),

    deleteIndustry: builder.mutation<{ success: boolean }, string>({
      query: (id) => ({
        url: `industry-types/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['industries'],
    }),
  }),
});

export const {
  useGetIndustriesQuery,
  useGetIndustryQuery,
  useCreateIndustryMutation,
  useUpdateIndustriesMutation,
  useDeleteIndustryMutation,
} = IndustryApi;
